export const types = {
    SET_USERS_COUNT: 'SET_USERS_COUNT',
    SET_USER_TO_STREAM: 'SET_USER_TO_STREAM',
    ADD_MSG: 'ADD_MSG',
};